import { Grid, Typography } from "@mui/material";
import DateRangePresetFilter from "./DateRangePresetFilter";
import TopBooksSection from "./TopBooksSection";
import PerformanceReportSection from "./PerformanceReportSection";

const Index = () => {
  return (
    <Grid container spacing={2.5}>
      <Grid item xs={12}>
        <DateRangePresetFilter />
      </Grid>

      <Grid item xs={12}>
        <TopBooksSection />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h3">Performance Report</Typography>
      </Grid>

      <Grid item xs={12}>
        <PerformanceReportSection />
      </Grid>
    </Grid>
  );
};

export default Index;
